import { render } from "./GetStarted.vue?vue&type=template&id=81a5529c&scoped=true"
import script from "./GetStarted.vue?vue&type=script&lang=js"
export * from "./GetStarted.vue?vue&type=script&lang=js"

import "./GetStarted.vue?vue&type=style&index=0&id=81a5529c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81a5529c"]])

export default __exports__